angular.module('iconoglobe')
.service('TimeSlots', function(){
  
  this.getTimeDate = function(time) {
    var timeParts = time.split(':');
    var d = new Date();
    d.setHours(timeParts[0]);
    d.setMinutes(timeParts[1]);
    d.setSeconds(timeParts[2]);
    return d;
  }
  this.getTimeSlots = function(startDate, endDate, interval) {
      var slots = [];
      var intervalMillis = interval * 60 * 1000;
      while (startDate < endDate) {
          // So that you get "00" if we're on the hour.
          var mins = ('0' + startDate.getMinutes()).slice(-2);
          var hour = ("0" + startDate.getHours()).slice(-2)
          slots.push( hour + ':' + mins);
          startDate.setTime(startDate.getTime() + intervalMillis);
      }
      return slots;
  }
  this.actionGetTimeSlots = function(cb) {
      
      var slots = this.getTimeSlots(
          this.getTimeDate("00:00:00"), this.getTimeDate("23:30:00"), 30
      );
      return slots;
  }
});